import { Navigate, Route, Routes } from 'react-router-dom'
import PublicLayout from '../layouts/PublicLayout'
import { Login } from '../pages/Login'

const PublicRoutes = () => (
    <Routes>
        <Route element={<PublicLayout />}>
            <Route path='/login' element={<Login />} />
            {/* <Route path='registration' element={<Registration />} />
      <Route path='forgot-password' element={<ForgotPassword />} /> */}
            <Route index element={<Navigate to='/auth/login' />} />
        </Route>
    </Routes>
)

export default PublicRoutes
